<div class="loader-wrapper">
  <app-loader
    [text]="'shared.loadingCampaign' | translate"
    [ngClass]="{ visible: loading }"
  ></app-loader>
  <div class="calendar-view-wrapper">
    <div class="calendar-header brand-view">
      <div class="left-content">
        <div
          class="button-transparent today"
          [class.active]="isCalendarOnThisMonth()"
          mwlCalendarToday
          [(viewDate)]="viewDate"
          (viewDateChange)="calendarDateChanged()"
        >
          <span>{{ "shared.today" | translate }}</span>
        </div>
        <div class="calendar-navigation">
          <div
            class="button-navigation"
            mwlCalendarPreviousView
            [view]="view"
            [(viewDate)]="viewDate"
            (viewDateChange)="calendarDateChanged()"
          >
            <span
              ><mat-icon
                _ngcontent-c14=""
                class="mat-icon material-icons"
                role="img"
                aria-hidden="true"
                >arrow_back_ios</mat-icon
              ></span
            >
          </div>
          <div
            class="button-navigation"
            mwlCalendarNextView
            [view]="view"
            [(viewDate)]="viewDate"
            (viewDateChange)="calendarDateChanged()"
          >
            <span
              ><mat-icon
                _ngcontent-c14=""
                class="mat-icon material-icons"
                role="img"
                aria-hidden="true"
                >arrow_forward_ios</mat-icon
              ></span
            >
          </div>
        </div>
        <h3>
          {{ viewDate | calendarDate: view + "ViewTitle" : language() }}
        </h3>
      </div>
    </div>
    <mwl-calendar-month-view
      [viewDate]="viewDate"
      [cellTemplate]="customCellTemplate"
      [events]="events"
      [refresh]="refresh"
      [locale]="language()"
      [weekStartsOn]="1"
    >
    </mwl-calendar-month-view>

    <ng-template #customCellTemplate let-day="day">
      <div
        [ngClass]="{ 'cal-day-cell--outbound': isDayOutsideRange(day.date) }"
      >
        <div class="cal-cell-top">
          <span class="cal-day-number">
            <i
              *ngIf="isDayOutsideRange(day.date)"
              class="cal-day-outbound-icon material-icons"
              >block</i
            >
            {{ day.date | calendarDate: "monthViewDayNumber" : language() }}
          </span>
        </div>
        <div class="cal-events">
          <div
            *ngFor="let event of day.events"
            class="cal-event cal-event--brand collapsed"
            mwlDraggable
            [ngClass]="{
              'cal-event--brand--post-log--facebook':
                !event.isSuggestedPost &&
                event.post.platform === PostPlatform.Facebook,
              'cal-event--brand--post-log--google':
                !event.isSuggestedPost &&
                event.post.platform === PostPlatform.Google,
              'cal-event--brand--post-log--linkedin':
                !event.isSuggestedPost &&
                event.post.platform === PostPlatform.LinkedIn,
              'cal-event--brand--suggested-post': event.isSuggestedPost
            }"
            [dropData]="{ event: event }"
            [dragAxis]="{
              x: event.draggable && !event.loading,
              y: event.draggable && !event.loading
            }"
            (mwlClick)="onEventClick($event, event)"
          >
            <mat-icon class="loading-icon">loop</mat-icon>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
